var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-functions-sort-desktop col-xs-12" }, [
    _c("div", { staticClass: "row" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-inline col-xs-9" }, [
        _c("span", [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.options.pageSize,
                  expression: "options.pageSize"
                }
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.options,
                      "pageSize",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.changed
                ]
              }
            },
            [
              _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "25" } }, [_vm._v("25")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
              _vm._v(" "),
              _c("option", { attrs: { value: "10000" } }, [_vm._v("All")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("span", [
          _c("label", [_vm._v("Sort by:")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.options.sortDirection,
                  expression: "options.sortDirection"
                }
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.options,
                      "sortDirection",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  _vm.changed
                ]
              }
            },
            [
              _c("option", { attrs: { value: "DESC" } }, [
                _vm._v("Recent first")
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "ASC" } }, [
                _vm._v("Oldest first")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("label", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.options.expandNotes,
                expression: "options.expandNotes"
              }
            ],
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.options.expandNotes)
                ? _vm._i(_vm.options.expandNotes, null) > -1
                : _vm.options.expandNotes
            },
            on: {
              change: function($event) {
                var $$a = _vm.options.expandNotes,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.options, "expandNotes", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.options,
                        "expandNotes",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.options, "expandNotes", $$c)
                }
              }
            }
          }),
          _vm._v("\n                Expand all notes\n            ")
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-right col-xs-3 label-fixed-width" }, [
      _c("label", [_vm._v("Results at a time:")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c0d68218", { render: render, staticRenderFns: staticRenderFns })
  }
}